@if (isPanelVisible) {
    @if (isT1) {
        <wk-t1-west-panel />
    }

    <div class="wk-cm__west-panel__toggle" (click)="toggleSidebar()" (keydown.enter)="toggleSidebar()" aria-hidden="true">
        <icon-pds3 class="wk-cm__west-panel--hide-on-collapse" name="wk-icon-chevron-double-left" />
        <icon-pds3 class="wk-cm__west-panel--show-on-collapse" name="wk-icon-chevron-double-right" />
    </div>
}
